import script from "./LogView.vue?vue&type=script&setup=true&lang=js"
export * from "./LogView.vue?vue&type=script&setup=true&lang=js"

import "./LogView.vue?vue&type=style&index=0&id=cd8744ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd8744ca"]])

export default __exports__